/**
 * 代理商相关常量
 */

/** 提现方式枚举 */
export enum WithdrawMethodEnum {
  Prepay = 'prepay',
  Bank = 'bank',
}
/** 提现方式选项 */
export const WITHDRAW_METHOD_OPTIONS: {
  label: string;
  value: WithdrawMethodEnum;
}[] = [
  { label: '预付账户', value: WithdrawMethodEnum.Prepay },
  { label: '银行账户', value: WithdrawMethodEnum.Bank },
];

/** 提现方式映射 */
export const WITHDRAW_METHOD_MAP: Record<WithdrawMethodEnum, string> = {
  [WithdrawMethodEnum.Prepay]: '预付账户',
  [WithdrawMethodEnum.Bank]: '银行账户',
};

/** 充值方式枚举 */
export enum RechargeMethodEnum {
  Online = 'online',
  Bank = 'bank',
}
/** 充值方式选项 */
export const RECHARGE_METHOD_OPTIONS: {
  label: string;
  value: RechargeMethodEnum;
}[] = [
  { label: '在线支付', value: RechargeMethodEnum.Online },
  { label: '银行账户', value: RechargeMethodEnum.Bank },
];
/** 充值方式映射 */
export const RECHARGE_METHOD_MAP: Record<RechargeMethodEnum, string> = {
  [RechargeMethodEnum.Online]: '在线支付',
  [RechargeMethodEnum.Bank]: '银行账户',
};

/** 充值状态枚举 */
export enum RechargeStatusEnum {
  Initial = 'initial',
  Pending = 'pending',
  Cancelled = 'cancelled',
  Success = 'success',
  Rejected = 'rejected',
}

/** 充值状态映射 */
export const RECHARGE_STATUS_MAP: Record<RechargeStatusEnum, string> = {
  [RechargeStatusEnum.Initial]: '未支付',
  [RechargeStatusEnum.Pending]: '审核中',
  [RechargeStatusEnum.Cancelled]: '已取消',
  [RechargeStatusEnum.Success]: '成功',
  [RechargeStatusEnum.Rejected]: '已驳回',
};

/** 充值状态颜色映射 */
export const RECHARGE_STATUS_COLOR_MAP: Record<
  RechargeStatusEnum,
  'default' | 'success' | 'error' | 'warning'
> = {
  [RechargeStatusEnum.Initial]: 'default',
  [RechargeStatusEnum.Pending]: 'default',
  [RechargeStatusEnum.Cancelled]: 'warning',
  [RechargeStatusEnum.Success]: 'success',
  [RechargeStatusEnum.Rejected]: 'error',
};

/** 充值状态选项（用于 Select 等表单组件） */
export const RECHARGE_STATUS_OPTIONS = Object.entries(RECHARGE_STATUS_MAP).map(
  ([key, label]) => ({
    label,
    value: key,
  }),
);

/** 充值状态 valueEnum（用于 ProTable 等组件） */
export const RECHARGE_STATUS_VALUE_ENUM = Object.entries(
  RECHARGE_STATUS_MAP,
).reduce(
  (acc, [key, label]) => {
    acc[key] = {
      text: label,
      status: RECHARGE_STATUS_COLOR_MAP[key as RechargeStatusEnum],
    };
    return acc;
  },
  {} as Record<
    string,
    { text: string; status: 'default' | 'success' | 'error' | 'warning' }
  >,
);

/** 线上充值支付方式映射（前端 -> 后端） */
export const PAYMENT_METHOD_MAP: Record<string, API.PaymentMethod> = {
  alipay: 'stripe_alipay',
  wechat: 'stripe_wechat',
  usdt: 'payssion_usdt',
  credit_card: 'stripe_card',
};

/** 线上充值支付方式名称映射 */
export const PAYMENT_METHOD_NAME_MAP: Record<API.PaymentMethod, string> = {
  stripe_alipay: '支付宝',
  stripe_wechat: '微信',
  payssion_usdt: 'USDT',
  stripe_card: '信用卡',
};

/** 套餐配置状态 valueEnum（用于 ProTable 等组件） */
export const PACKAGE_CONFIGURED_STATE_VALUE_ENUM: Record<
  number,
  { text: string; color: string }
> = {
  0: { text: '未配置', color: 'warning' },
  1: { text: '已配置', color: 'success' },
  2: { text: '无配置', color: 'default' },
};
